import { Box, styled, Button, darken } from '@mui/material';

export const DialogButtonsContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 2,
}));

export const FormulaButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: darken(theme.palette.common.white, 0.9),
  },
  textTransform: 'none',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: darken(theme.palette.common.white, 0.9),
  },
}));

export const ApplyButton = styled(Button)(({ theme }) => ({
  minWidth: theme.spacing(14),
  borderRadius: theme.spacing(3),
}));
